<template>
  <button
    class="button"
    :class="{ [`button_${type}`]: true, button_loading: loading, button_disabled: disabled }"
  >
    <loader v-if="loading" size="15px" border="3px" absolute />
    <slot></slot>
  </button>
</template>

<script>
import Loader from '@/components/Loader';

export default {
  props: ['type', 'loading', 'disabled'],
  components: { Loader },
};
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  position: relative;
  padding: 4px 8px;
  background: var(--bg);
  border: 1px solid lighten($primary, 20);
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  word-break: break-word;

  &_primary {
    background-color: $primary;
    color: #fff;
  }

  &_negative {
    background-color: #ff4d4d;
    border-color: #ff4d4d;
    color: #fff;
  }

  &_loading {
    pointer-events: none;
  }

  &_disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
